import networkService from '../Network/NetworkManager';

const APPURL = require('../Constants/URLConstants');

// Records a click on a plan card in Skua's billing funnel (pricing:plan_clicked). `source` is the screen:
// 'plans_page' or 'upgrade_panel'. Fire and forget: it never blocks the click.
export const trackPlanClick = (source, planName) => {
  if (!source || !planName) {
    return;
  }
  networkService
    .networkCall(
      APPURL.URLPaths.planClick,
      'POST',
      JSON.stringify({source, plan_name: String(planName)}),
    )
    .catch(() => {});
};
